const gtmPusher = (gtmObj, productArr) => {
  let mappedProducts = [];
  const customizations = [];
  if (productArr && productArr.length > 0) {
    mappedProducts = productArr.map(product => {
      if (product.sublines && product.sublines.length > 0) {
        product.sublines.forEach(subline => {
          const customization = {
            id: '',
            name: 'customization',
            variant: subline.variant || '',
            category: 'add on',
            quantity: subline.quantity || 1,
            dimension10: '',
            price: subline.line_total || null
          };
          customizations.push(customization);
        });
      }

      const extraValues = {};
      if (product.attributes) extraValues.attributes = product.attributes;
      if (window.navigator.platform !== undefined)
        extraValues.os = window.navigator.platform;
      if (product.sizes) {
        product.sizes.forEach(size => {
          if (size.name === product.size) {
            extraValues.sku_id = size.sku_id;
          }
        });
      }

      return {
        id: product.product_id || null,
        name: product.product || null,
        quantity: Number(product.quantity) || null,
        price: product.unit_net
          ? product.unit_net
          : product.prices.recommended_retail_price || null,
        dimension11: product.size || null,
        brand:
          product.attributes && product.attributes.item_type
            ? product.attributes.brand
            : null,
        category:
          product.attributes && product.attributes.item_type
            ? product.attributes.item_type
            : null,
        dimension10:
          product.attributes && product.attributes.team
            ? product.attributes.team
            : 'no club',
        variant: null, // colors or custom print / player name for customizations
        list: gtmObj.list || null,
        position: product.position || 0,
        imageUrl: product.image_url,
        ...extraValues
      };
    });

    mappedProducts = [...mappedProducts, ...customizations];
  }

  const pushObj = {
    event: gtmObj.event, // ex.'checkout'
    eventCategory: gtmObj.eventCategory || 'ecommerce',
    eventAction: gtmObj.eventAction,
    eventLabel: gtmObj.eventLabel,
    eventValue: gtmObj.eventValue || 0,
    eventNonInteraction: gtmObj.eventNonInteraction || false,
    virtualPath: gtmObj.virtualPath || null // ex.'/billing'
  };

  if (gtmObj.event === 'productDetailView') {
    pushObj.ecommerce = {
      currencyCode: gtmObj.currencyCode || null,
      detail: {
        actionField: {
          list: gtmObj.list || ''
        },
        products: mappedProducts
      }
    };
  }

  if (gtmObj.event === 'productClick') {
    pushObj.ecommerce = {
      currencyCode: gtmObj.currencyCode || null,
      click: {
        actionField: {
          list: gtmObj.list || ''
        },
        products: mappedProducts
      }
    };
  }

  if (gtmObj.event === 'impressionView') {
    pushObj.ecommerce = {
      currencyCode: gtmObj.currencyCode || null,
      impressions: mappedProducts
    };
  }

  if (gtmObj.event === 'addToCart') {
    pushObj.ecommerce = {
      currencyCode: gtmObj.currencyCode || null,
      add: {
        actionField: {
          list: gtmObj.list || ''
        },
        products: mappedProducts
      }
    };
    const copyObj = JSON.parse(JSON.stringify(pushObj));
    copyObj.event = 'cartUpdate';
    copyObj.ecommerce.action = 'item_added';
    if (gtmObj.currentCart !== undefined) {
      copyObj.ecommerce.add.currentCart = gtmObj.currentCart;
    }
    const objectsArray = [].concat(pushObj, copyObj);
    if (window.dataLayer) return window.dataLayer.push(...objectsArray);
  }

  if (gtmObj.event === 'removeFromCart') {
    pushObj.ecommerce = {
      currencyCode: gtmObj.currencyCode || null,
      remove: {
        actionField: {
          list: gtmObj.list || ''
        },
        products: mappedProducts
      }
    };
    const copyObj = JSON.parse(JSON.stringify(pushObj));
    copyObj.event = 'cartUpdate';
    copyObj.ecommerce.action = 'item_removed';
    if (gtmObj.currentCart !== undefined) {
      copyObj.ecommerce.remove.currentCart = gtmObj.currentCart;
    }
    const objectsArray = [].concat(pushObj, copyObj);
    if (window.dataLayer) return window.dataLayer.push(...objectsArray);
  }

  if (gtmObj.event === 'checkout') {
    pushObj.ecommerce = {
      currencyCode: gtmObj.currencyCode || null,
      checkout: {
        actionField: {
          step: gtmObj.step, // ex.1
          option: gtmObj.option || '' // ex.'MobilePay'
        },
        products: mappedProducts
      }
    };
  }

  if (gtmObj.event === 'purchase') {
    pushObj.ecommerce = {
      currencyCode: gtmObj.currencyCode || null,
      purchase: {
        actionField: {
          id: gtmObj.orderId || '',
          revenue: gtmObj.revenue,
          shipping: gtmObj.shipping,
          tax: gtmObj.tax,
          coupon: gtmObj.coupon,
          cartTotalAmount: gtmObj.cartTotalAmount
        },
        products: mappedProducts
      },
      address: {
        name: gtmObj.name,
        company: gtmObj.company,
        address: gtmObj.address,
        address2: gtmObj.address2,
        postcode: gtmObj.postcode,
        town: gtmObj.town,
        country: gtmObj.country,
        phoneNumber: gtmObj.phoneNumber,
        email: gtmObj.email
      }
    };
  }

  if (gtmObj.event === 'cartState') {
    pushObj.ecommerce = {
      currencyCode: gtmObj.currencyCode || null,
      cartState: {
        products: mappedProducts
      }
    };
  }

  // console.log('PushObj: ', pushObj);
  if (window.dataLayer) return window.dataLayer.push(pushObj);
  return false;
};

export default gtmPusher;
